export enum SubmissionType {
  Complaint = 'Complaint',
  Suggestion = 'Suggestion'
}
